export function DistributorDevice({
    uid,
    bluetoothId,
    multiIndex,
    description,
    type,
    originalType,
    lastActivity,
    locationId,
    locationName,
    roomName,
    locationAdminEmail,
    warrantyStart,
    status,
    isVirtual,
} = {}) {
    return {
        uid,
        bluetoothId,
        multiIndex,
        description,
        type,
        originalType,
        lastActivity,
        locationId,
        locationName,
        roomName,
        locationAdminEmail,
        warrantyStart,
        status,
        isVirtual,
    };
}